import { render, staticRenderFns } from "./ReportOverviewStart.vue?vue&type=template&id=0faa7a06&"
import script from "./ReportOverviewStart.vue?vue&type=script&lang=js&"
export * from "./ReportOverviewStart.vue?vue&type=script&lang=js&"
import style0 from "./ReportOverviewStart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VIcon})
